module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("oh so versatile handbag")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_vm._v("Fabric handbags are a wonderful way of accessorizing any outfit. Here a soft brown and green checked wool has been combined with real suede to create a smart everyday bag, but it is just as easy to make one suitable for a wedding or a special night out (see beribboned evening bag). The bag is constructed in two pieces with a seam running across the bottom corners to give it more shape. If you prefer you can change the two shorter handles to a satchel-style strap.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/16-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("For the bag shown here, the fabrics were sourced from charity or thrift store finds – a checked wool skirt with a silky lining and a suede jacket. The funky 3-D flower is finished with a vintage button.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/17-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "need"
  }, [_vm._v("you will need …")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 30 × 80cm (12 × 31"), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in) checked wool remnant")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 30 × 80cm (12 × 31"), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in) lining fabric")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 30 × 80cm (12 × 31"), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in) canvas for interlining")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 15 × 16cm (6 × 6"), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) lining fabric for pocket")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• suede jacket or skirt (not panelled) for handles and decoration")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• scrap of plain wool")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• double-sided fusible webbing (bondaweb)")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• fabric spray adhesive")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• one large button")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• metallic magnetic clasp fastener")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• sewing threads to match fabrics")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("techniques")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc1"
    }
  }, [_vm._v("basic sewing kit")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc2"
    }
  }, [_vm._v("using a sewing machine")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc8"
    }
  }, [_vm._v("using bondaweb")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc99"
    }
  }, [_vm._v("topstitching")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc100"
    }
  }, [_vm._v("understitching")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc101"
    }
  }, [_vm._v("slipstitch")]), _vm._v(" … "), _c('strong', [_vm._v("templates")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#toc102"
    }
  }, [_vm._v("large and small flowers")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#toc6"
    }
  }, [_vm._v("bag body")]), _vm._v(" …")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("1")]), _vm._v(" Download the bag body pattern for the oh so versatile handbag and cut out. Use the pattern to cut one front and one back from the wool fabric; two from the interlining; and two from the lining fabric. For the handles, cut two strips measuring 8 × 50cm (3"), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("8")]), _vm._v(" × 20in) from the suede.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("2")]), _vm._v(" Using the large & small flower templates for the oh so versatile handbag, draw out the large and small flower motifs onto bondaweb. Fuse the larger one onto the suede and the smaller one onto the scrap of plain wool. Cut out, peel off the paper backing and fuse both flowers onto corresponding fabrics. Using machine zigzag stitch, sew round the edges of both flowers and put to one side.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("3")]), _vm._v(" Using the fabric spray adhesive, spray the canvas (interlining) and bond to the wrong side of the front and back pieces of the main body.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("4")]), _vm._v(" Place the small flower on top of the large flower and pin to the centre of the right side of the front bag. Starting at the middle point, using machine straight stitch, sew out approx 3cm (1"), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) into each petal to secure the flower.")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Alternatively why not appliqué butterflies right across the front of the bag and along the straps too.")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("5")]), _vm._v(" To prepare the inside pocket, turn over one of the longer edges by 1cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("8")]), _vm._v("in), and press and turn over another 1cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("8")]), _vm._v("in). Press and topstitch. Zigzag round the remaining three edges to neaten and then press under 1cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("8")]), _vm._v("in). Pin into position (see body template) on the back piece of the bag lining, and sew a double row of topstitch around the three edges to secure.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/19-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("6")]), _vm._v(" To make up the bag and lining, pin right side front and back pieces together and sew the side seams and bottom seam of the bag using a 1cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("8")]), _vm._v("in) seam allowance. Leave a 10cm (4in) gap in the bottom seam of the lining to turn the bag through. Press the seams flat.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("7")]), _vm._v(" To create the base for the bag, and still working from the wrong side, fold the bottom bag corner open along the bottom seam, measure in 3cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("11")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) and machine stitch a straight stitch at right angles across the width. Repeat on all corners of both the top fabric and the lining.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/19-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("8")]), _vm._v(" With right sides together, pin, tack (baste) and stitch the top edge of the bag to the top edge of the lining using a 1cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("8")]), _vm._v("in) seam allowance.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/19-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("9")]), _vm._v(" Turn through to the right side. Press the seams up towards the lining and understitch on the lining side (see illustration).")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("10")]), _vm._v(" Push the lining into the bottom corners and press with steam ensuring that you give the sides a crisp edge to create the side panels.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/20-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("11")]), _vm._v(" Take the handles and press the long edges under 1cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("8")]), _vm._v("in). Pin and topstitch all the way around the edges. Press the short edges under 1cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("8")]), _vm._v("in) and pin into position (see body template). Stitch a 2cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) square, 1mm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("20")]), _vm._v("in) from the edge, to secure each strap end and finish with a line of stitching from corner to corner for extra strength (see photograph).")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/20-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("12")]), _vm._v(" Insert the magnetic clasp following the manufacturer’s instructions, before slipstitching the lining in place (see tip).")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("13")]), _vm._v(" Finally sew the button onto the centre of the flower. Give the finished bag a final steam press.")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("To prevent show-through on the bag front, insert a strip of canvas between the fabric and the clasp wings before pushing into place.")])]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_vm._v("beribboned evening bag")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The handbag is so easy to make, you’ll want to sew several to match your best outfits. This beautiful silk devoré evening bag is mounted onto pink linen and embellished with complementary beads. Rather than using a metallic clasp, a luxurious silk ribbon has been used to fasten the bag. Try creating a unique designer bag of your very own.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/21-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428378c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c02.vue
// module id = 72
// module chunks = 0